import React from 'react';
import './card-sec2.css'
import pic5 from '../../assets/pic5.png'
import pic6 from '../../assets/pic6.png'
import { useEffect } from 'react';
import { useState } from 'react';


const Cardsec2 = (props) => {

const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec2');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);








    return ( 
        <article className={`card-sec2 ${animate ? 'animate' : ''}`}>
                <img className='triangle-sec2' src={pic5} alt='pic '></img>
                <nav className='green-circle-sec2'>
                    <img src={pic6} alt='pic'></img>
                </nav>
                <h2 className='sec2-text'>{props.title}</h2>
        </article>
     );
}
 
export default Cardsec2;